import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {PaginatedResult} from '../restaurant-manager.models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityService {

  constructor(private apiService: ApiService) {}

  private static convertParams(params: any): string {
    return btoa(JSON.stringify(params));
  }

  list<T>(entity: string, params, type: new(obj: any) => T): Observable<PaginatedResult<T>> {
    return this
      .apiService
      .get<PaginatedResult<T>>('/entities/' + entity + '?params=' + EntityService.convertParams(params), true)
      .pipe(map(p => new PaginatedResult<T>(p, type)));
  }

  getAll<T>(entity: string, params, type: new(obj: any) => T): Observable<T[]> {
    return this
      .apiService
      .get<T[]>('/entities/' + entity + '?params=' + EntityService.convertParams(params), true)
      .pipe(map(result => result.map(e => new type(e))));
  }

  getById<T>(entity: string, id: string, type: new(obj: any) => T): Observable<T> {
    return this
      .apiService.get<T>('/entities/' + entity + '/' + id, true)
      .pipe(map(result => new type(result)));
  }

  update<T>(entity: string, data, type: new(obj: any) => T): Observable<T> {
    const id = data.id;
    delete data.id;
    return this
      .apiService.put<T>('/entities/' + entity + '/' + id, data, true)
      .pipe(map(result => new type(result)));
  }

  add<T>(entity: string, data, type: new(obj: any) => T): Observable<T> {
    return this
      .apiService.post<T>('/entities/' + entity, data, true)
      .pipe(map(result => new type(result)));
  }

  remove(entity: string, id: string): Observable<any> {
    return this.apiService.delete<any>('/entities/' + entity + '/' + id, true);
  }

  reorder(data): Observable<any> {
    return this
      .apiService.post<any>('/sort-entities', data, true)
      .pipe(map(result => result));
  }

}
